import { merge } from 'lodash';

const initialState = {
  /* Campos etapa 1 */
  titulo: '',
  uploadedFiles: [],

  /* Campos etapa 2 */
  dataBase: null,
  dataProjetada: null,
  taxaMediaDep: 0,
  possuiDevolucoes: false,
  possuiKit: false,
  percentuais: {
    DemaisItens: { label: 'Demais Itens', perc: '0.0' },
    IncorpRedes: { label: 'Incorporação de Redes', perc: '0.0' },
    Plpt: { label: 'PLPT', perc: '0.0' }
  },
  valores: {
    ValorDevolucao: 0,
    ValorDemaisItens: 0,
    ValorIncorpRedes: 0,
    ValorPlpt: 0
  },
  arquivoDelimitador: '|',
  arquivoInvolucro: '"',
  arquivoEscape: '"'
};

const state = initialState;

const getters = {};

const actions = {
  setObrigacoesEspeciais({ commit }, value) {
    commit('SET_OBRIGACOES_ESPECIAIS', value);
  },
  clearObrigacoesEspeciais({ commit }) {
    commit('CLEAR_OBRIGACOES_ESPECIAIS', initialState);
  }
};

const mutations = {
  SET_OBRIGACOES_ESPECIAIS: (state, value) => {
    if (value.uploadedFiles) {
      state.uploadedFiles = value.uploadedFiles;
    }
    merge(state, value);
  },
  CLEAR_OBRIGACOES_ESPECIAIS: (state, value) => {
    state.uploadedFiles = [];
    merge(state, value);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
